import { AuthenticationService } from './../../servicios/authentication.service';
// prettier-ignore
import { Component, OnInit, EventEmitter, ViewChild, Input, OnChanges, HostListener } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, } from "@angular/forms";
import { saveAs } from 'file-saver';
import { AguasService } from "../../servicios/aguas.service";
import { EnviarCorreoService } from "../../servicios/enviar-correo.service";
import { PersonasService } from "../../servicios/personas.service";
import { Aguas, CargosDetalles, MedioPagos, json_in, CatMedioPagos, CatCfdiUsos, AuxJasper, DatosFacturacionCaja, PersonaClientes, FacturacionData, ParametroJasper, Convenios, BuscaConveniosInput, Privilegios, DatosCfdiFacturas, } from "../../entidades/entidades";
import { Observable, } from "rxjs";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { RAguasPersonas, EstadoCuentaInformacionInput, EnviarCorreo } from "../../entidades/entidades";
import { Personas, } from '../../entidades/entidades';
import { RAguasPersonasService } from "../../servicios/r-aguas-personas.service";
import { CargosDetallesInput } from "../../entidades/entidades";
import { MedioPagosComponent } from "../../componentes/medio-pagos/medio-pagos.component";
import { CargosDetallesComponent } from "../../componentes/cargos-detalles/cargos-detalles.component";
import { RegistraPagosService } from "../../servicios/registra-pagos.service";
import { CatCfdiUsosService } from "app/servicios/cat-cfdi-usos.service";
import { JasperService } from "app/servicios/jasper.service";
import { CatMedioPagosService } from "app/servicios/cat-medio-pagos.service";
import { DatosCfdiFacturasService } from "app/servicios/datos-cfdi-facturas.service";
import { EstadoCuentaInformacionComponent } from '../../componentes/estado-cuenta-informacion/estado-cuenta-informacion.component';
import { DatosFacturacionCajaComponent } from '../datos-facturacion-caja/datos-facturacion-caja.component';
import { async } from '@angular/core/testing';
import { ConveniosChildService } from 'app/servicios/convenios-child.service'
import { ConfirmationService } from 'primeng/api';
import { TicketService } from 'app/servicios/ticket.service';
import { BuscaPersonaClientesService } from '../../servicios/busca-persona-clientes.service';
import { PersonaClientesService } from '../../servicios/persona-clientes.service';
import { Router } from '@angular/router';
import { CatNivelSeguridadesService } from 'app/servicios/cat-nivel-seguridades.service';
import { execDbService } from 'app/servicios/exec-db.service';

@Component({
    selector: "app-cobros-agua",
    templateUrl: "./cobros-agua.component.html",
    styleUrls: ["./cobros-agua.component.css"],
})
export class CobrosAguaComponent implements OnInit {
    @Input("aguasInput") aguasInput: number;


    muestraMensaje = new MuestraMensaje();
    CajaForm: FormGroup;
    public datosFacturacion = new DatosFacturacionCaja();
    public datosFacturacionCaja$ = new EventEmitter<DatosFacturacionCaja>();
    public datosenviarCorreo$ = new EventEmitter<EnviarCorreo>();
    public aguas$: Observable<Aguas>;
    public aguasLimpio: Aguas;
    public idAguasProceso: number;
    public rAguasPersonas: RAguasPersonas;
    public personas$: Observable<Personas>;
    public personasLimpio: Personas;
    public enviaCorreo: EnviarCorreo = new EnviarCorreo();
    public cargosDetallesInput$ = new EventEmitter<CargosDetallesInput>();
    public cargosDetallesInputLimpio: CargosDetallesInput;
    public cargosDetalles: CargosDetalles;
    public medioPagos: MedioPagos;
    public noLimpiar: boolean = false;
    public aux: number = 1;

    @ViewChild(CargosDetallesComponent, { static: false }) childCargosDetalles;
    @ViewChild(MedioPagosComponent, { static: false }) childMedioPagos;
    @ViewChild(EstadoCuentaInformacionComponent, { static: false }) childEstadoCuentaInformacion;
    @ViewChild(DatosFacturacionCajaComponent, { static: false }) childDatosFacturacionCaja;

    mediosPagosRecibidos: any[] = [];
    cargosDetallePagar: CargosDetalles[] = [];
    pagar = true;
    total: number;
    json_in: json_in;
    usuario: any;
    totalMedio: number = 0;
    public totalMedioRecibido: number = 0;
    _id_factura: number;
    catalogosForm: FormGroup;
    mensajeForm: FormGroup;
    catMedioPagos: CatMedioPagos[] = [];
    catUsoCfdi: CatCfdiUsos[] = [];
    mediopago = new CatMedioPagos();
    public idCobro: number;
    usoCFDI = new CatCfdiUsos();
    public auxJasper: AuxJasper;
    private _jasperService: JasperService;
    facturacionData: FacturacionData;
    personaCliente = new PersonaClientes();
    public medioP$ = new EventEmitter<MedioPagos>();
    public respuestaF: any;
    flag: boolean = false;
    convenioActivo: boolean = false;
    private flagFacturacionActiva: boolean = true;
    estadoCuentaTable: any;
    FechaRecalculo: any = null;
    conRedondeo: boolean = true;
    vigenciaIni: any;
    _idAgua: number;

    public idNivel;
    public esAbono: boolean = true;
    public isCFDI: boolean = false;

    mensaje: string;
    public estadoCuentaInformacionInput$ = new EventEmitter<
        EstadoCuentaInformacionInput
    >();
    public estadoCuentaInformacionLimpio: EstadoCuentaInformacionInput;

    display: boolean = false;
    showDialog() {
        this.display = true;
    }
    display1: boolean = false;
    showDialog1() {
        this.display1 = true;
    }
    public progressBar = false;
    showBar() {
        this.progressBar = true;
    }

    errorTimbre: boolean = false;
    showErrorTimbre() {
        this.errorTimbre = true;
    }

    enviaC: boolean = false;
    handleChange(e) {
        this.enviaC = e.checked;
    }

    // Escuchar el evento de teclado a nivel del documento
    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        // Verificar si la tecla presionada es "*" (tanto minúscula como mayúscula)
        if (event.key.toLowerCase() === '*' && !this.pagar) {
        event.preventDefault();
        this.Pagar();
        }
    }
    constructor(
        private formBuilder: FormBuilder,
        private aguasService: AguasService,
        private rAguasPersonasService: RAguasPersonasService,
        private personasService: PersonasService,
        private enviarCorreoService: EnviarCorreoService,
        private registraPagosService: RegistraPagosService,
        private catCfdiUsosService: CatCfdiUsosService,
        private catMedioPagosService: CatMedioPagosService,
        private datosCfdiFacturasService: DatosCfdiFacturasService,
        private authenticationService: AuthenticationService,
        public conveniosChildService: ConveniosChildService,
        private confirmationService1: ConfirmationService,
        private router: Router,
        private catNivelSeguridadesService: CatNivelSeguridadesService,
        private execDbService: execDbService,
        private buscaPersonaClientesService: BuscaPersonaClientesService,
        private personaClientesService: PersonaClientesService,
        private ticketService: TicketService,
    ) {
        // se soluciona el error de form group
        this.CajaForm = new FormGroup({
            observaciones: new FormControl(),
            total: new FormControl(),
            restante: new FormControl(),
            cambio: new FormControl(),
            pagado: new FormControl(),
            saldoF: new FormControl(),
            FechaRecalculo: new FormControl(),
            //conRedondeo: new FormControl(false),
        });
        this.catalogosForm = new FormGroup({
            id: new FormControl(),
            idMedioPago: new FormControl(),
        });

        this.mensajeForm = new FormGroup({
            mensaje_: new FormControl(),
        });

    }

    async OnChanges() {


    }

    async ngOnInit() {
        //Obtenemos el nivel del privilegio.
        let objUrl = new Privilegios();
        objUrl.descripcion = "/ingresos/recalc-caja";
        var objNivelSeg = await this.catNivelSeguridadesService
            .GetNivelPorPrivilegio(objUrl)
            .toPromise();
        this.idNivel = objNivelSeg;

        await this.authenticationService.getUserByToken();
        this.usuario = this.authenticationService.currentUserValue;
        this.conRedondeo = true;
        this.CajaForm = this.formBuilder.group({
            observaciones: [undefined],
            total: [0],
            restante: [0],
            cambio: [0],
            pagado: [0],
            abano: [0],
            saldoF: ['$0.00'],
            //conRedondeo: [true],
            FechaRecalculo: null,
        });
        this.catalogosForm = this.formBuilder.group({
            id: [undefined],
            idMedioPago: [undefined],
        });

        this.mensajeForm = this.formBuilder.group({
            mensaje_: [undefined],
        });

        if (this.aguasInput === undefined) {
            return;
        }

        this.catalogosForm.patchValue({
            idMedioPago: 1
        });

        
        //debugger;
        this.getAllCatMedioPagos();
        this.getAllCfdiUsos();
        this.childAguaBuscaCuentas(this.aguasInput);
        


    }

    ngOnChanges() {
        if (this.aguasInput) {
            this.childAguaBuscaCuentas(this.aguasInput);
        }
    }

    // =====================================================
    // Carga principal
    // =====================================================
    async childAguaBuscaCuentas(idAgua: number) {
        //if (this.noLimpiar == false) {
        try {
            this.aux = 0;
            this.idAguasProceso = idAgua;
            //const medidoresBusquedas = new Medidores();
            this.limpiaInput();
            if (!this.idAguasProceso) {
                this.aguas$ = await this.aguasService.getSingle(0);
                this.personas$ = await this.personasService.getSingle(0);

                // medidoresBusquedas.idAgua = 0;
                // this.medidores$ = await this.medidoresService.getBusquedas(
                //   medidoresBusquedas
                // );
                this.limpiaInput();
                return;
            }
            // carga formulario de agua
            this.aguas$ = await this.aguasService.getSingle(idAgua);

            //Carga formulario de personas
            const rAguasPersonasBusquedas = new RAguasPersonas();
            rAguasPersonasBusquedas.idAgua = idAgua;

            await this.getRAguasPersonas(rAguasPersonasBusquedas);
            this.personas$ = await this.personasService.getSingle(
                this.rAguasPersonas.idPersona
            );
            this.buscaSolicitante();
            //Carga formulario estado-cuentas
            //let estadoCuentaInformacionInput = new EstadoCuentaInformacionInput();
            //estadoCuentaInformacionInput.idAgua = aguas.id;
            //estadoCuentaInformacionInput.cuentaAgua = aguas.cuentaAgua;
            //await this.estadoCuentaInformacionInput$.emit(estadoCuentaInformacionInput);
            this._idAgua = idAgua;
            // Carga detalle adeudos
            const cargosDetallesInput = new CargosDetallesInput();
            cargosDetallesInput.idAgua = idAgua;
            cargosDetallesInput.idEstatus = 1;
            cargosDetallesInput.fechaCalculos = this.FechaRecalculo;
            await this.cargosDetallesInput$.emit(cargosDetallesInput);

            this.CajaForm.patchValue({
                total: 0,
                restante: 0,
                cambio: 0,
                pagado: 0,
                saldoF: '$0.00',
                //conRedondeo: true,
                FechaRecalculo: this.FechaRecalculo,
            });

            const medioP = new MedioPagos();
            medioP.id = 1;
            medioP.monto = 0;
            await this.medioP$.emit(medioP);

            await this.buscaConvenio(this._idAgua);

        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            console.log("Paso por childAguas");
        }

    }

    async childtotal(cargosDetallesInput: CargosDetallesInput) {
        try {
            //==============================================================
            // Limpia formulario de totales y medios pago
            //==============================================================
            this.CajaForm.patchValue({
                total: 0,
                restante: 0,
                cambio: 0,
                pagado: 0,
                saldoF: '$0.00',
                //conRedondeo: true,
                FechaRecalculo: this.FechaRecalculo,
            });

            this.totalMedio = 0;

            const medioRecarga = new MedioPagos();
            medioRecarga.id = 1;
            medioRecarga.monto = 0;
            await this.medioP$.emit(medioRecarga);

            //==============================================================
            // Asigna y emite el total a medios pago
            //==============================================================

            var total = 0;
            total = this.childCargosDetalles.total;
            if(this.conRedondeo){
                this.CajaForm.patchValue({total: Math.ceil(total),});
            }else{
                this.CajaForm.patchValue({total: total,});
            }
            this.pagar = false;

            const medioP = new MedioPagos();
            if (total) { medioP.monto = total; } else { medioP.monto = 0; };

            // console.log("Total a Emitir? ", medioP);

            this.medioP$.emit(medioP);
            if(this.conRedondeo){
                this.total = Math.ceil(total);
            }else{
                this.total = total;
            }
            if (this.childMedioPagos) {
                this.childMedioPagos.limpiaGrid();
            }
        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            console.log("Paso por childTotal");
        }
    }

    async getRAguasPersonas(rAguasPersonas: RAguasPersonas) {
        try {
            const datoRetorno = await this.rAguasPersonasService
                .getBusquedas(rAguasPersonas)
                .toPromise();
            this.rAguasPersonas = datoRetorno[0];
        } catch (e) {
            if (e.response) {
                throw { message: e.response.data };
            } else {
                throw e;
            }
        } finally {
            console.log("Paso por getRAguasPersonas");
        }
    }

    // =====================================================
    //Pagar
    // =====================================================
    async Pagar() {
        try {
            if (this.catalogosForm.value.idMedioPago == null) {
                this.noLimpiar = true;
                throw new Error("Debe seleccionar un Método de Pago.");
            }
            if (this.catalogosForm.value.id == null && this.flagFacturacionActiva) {
                this.noLimpiar = true;
                throw new Error("Debe seleccionar el uso del CFDI.");
            }
            if (this.childCargosDetalles.total == 0 && this.childMedioPagos.esAbono === false) {
                this.noLimpiar = true;
                throw new Error("Debe seleccionar conceptos a cobrar.");
            }
            if (this.personaCliente.idTipoPersona === 1 && !this.personaCliente.nombre)
                throw new Error('Seleccione un cliente');

            if (this.personaCliente.idTipoPersona === 2 && !this.personaCliente.razonSocial)
                throw new Error('Seleccione un cliente');

            if (this.personaCliente.id != 1 && !this.personaCliente.cp && this.flagFacturacionActiva)
                throw new Error('Debes de indicar el código postal en los datos de facturación');

            if (!this.personaCliente.idRegimenFiscal && this.flagFacturacionActiva)
                throw new Error('El solicitante debe de tener un régimen fiscal específicado');

            if (this.personaCliente.id != 1 && this.personaCliente.rfc == "XAXX010101000" && this.flagFacturacionActiva)
                throw new Error('Debes seleccionar al público general para el uso del rfc genérico');

            this.json_in = new json_in();
            //============================================================================
            // Validaciones Cuando No Se Especifica Un Monto de Pago O Metodos De Pago
            //============================================================================
            //debugger;
            //if (this.totalMedio < Math.ceil(this.childCargosDetalles.total) && this.childMedioPagos.esAbono === false && this.childMedioPagos.MedioPagoTable.length == 0) {
            if (this.totalMedio < this.total && this.childMedioPagos.esAbono === false && this.childMedioPagos.MedioPagoTable.length == 0) {
                const medioP = new MedioPagos();
                medioP.idMedioPago = 1;
                medioP.monto = this.childCargosDetalles.total;
                // console.log("Total Medio a Emitir: ", medioP);
                await this.medioP$.emit(medioP);
                this.json_in.MedioPagos_in.push(medioP);
                await this.catalogosForm.patchValue({ idMedioPago: 1, id: 3 });
            } else if (this.childMedioPagos.esAbono === true) {

            } 
            // else if (this.totalMedio < Math.ceil(this.childCargosDetalles.total) && this.childMedioPagos.esAbono === false && this.childMedioPagos.MedioPagoTable.length > 0) {
            //     this.muestraMensaje.error('No has cubierto el total a pagar.', 'top', 'center');
            //     return;
            // }   // A peticion de la encargada de informatica, se quita la validacion, y cuando paguen de menos, se aplicara directamente como abono.

            for (var i = 0; i < this.childCargosDetalles.cargosDetallesTable.length; i++) {
                if (this.childCargosDetalles.cargosDetallesTable[i].selected) {
                    this.cargosDetalles = new CargosDetalles();
                    //Consumo agua

                    this.cargosDetalles.idCargo = this.childCargosDetalles.cargosDetallesTable[i].idCargo;
                    //Drenaje
                    this.json_in.CargosDetalles_in.push(this.cargosDetalles);
                }
            }
            this.json_in.Cobros_in.total = this.childCargosDetalles.total;


            // console.log("Este es el json", this.json_in);
            //=============================================
            // Obtiene medios de pago.
            //=============================================

            //ASIGNA MEDIOS DE PAGO
            for (var i = 0; i < this.childMedioPagos.MedioPagoTable.length; i++) {
                this.medioPagos = new MedioPagos();
                if (this.childMedioPagos.MedioPagoTable[i].idBanco != null) {
                    this.medioPagos.idBanco = this.childMedioPagos.MedioPagoTable[i].idBanco;
                }
                this.medioPagos.idMedioPago = this.childMedioPagos.MedioPagoTable[i].idMedioPago;
                this.medioPagos.monto = this.childMedioPagos.MedioPagosTable[i].monto;

                if (this.childMedioPagos.MedioPagoTable[i].autorizacionTarjeta != null) {
                    this.medioPagos.autorizacionTarjeta = this.childMedioPagos.MedioPagoTable[i].autorizacionTarjeta;
                }
                if (this.childMedioPagos.MedioPagoTable[i].referencia != null)
                    this.medioPagos.referencia = this.childMedioPagos.MedioPagoTable[i].referencia;
                this.medioPagos.fechaDeposito = this.FechaRecalculo;
                this.json_in.MedioPagos_in.push(this.medioPagos);
            }


            //=============================================
            // Registra pago con API
            //=============================================

            const caja = this.CajaForm.value;
            this.json_in.Cobros_in.idConceptoGral = 1;
            this.json_in.Cobros_in.idAgua = this.idAguasProceso;
            this.json_in.Cobros_in.idUsuarioCobro = this.usuario.id;
            this.json_in.Cobros_in.observaciones = caja.observaciones;
            this.json_in.Cobros_in.conRedondeo = this.conRedondeo;
            this.json_in.Cobros_in.esAbono = this.childMedioPagos.esAbono;


            await this.confirmaPago();

            //this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
            console.log(this.muestraMensaje.error);

        } finally {
            console.log("Paso por getRAguasPersonas");
            this.progressBar = false;
            if (this.noLimpiar) {
                this.childAguaBuscaCuentas(this.aguasInput);
            }
        }
    }

    async childMediosPagos(buscaMedioPago: MedioPagos) {
        try {

            this.pagar = false;
            if (this.childMedioPagos.esAbono === true) {
                const medioP = new MedioPagos();
                medioP.monto = 0;

                this.medioP$.emit(medioP);
                this.total = 0;

            } else if (this.childMedioPagos.esAbono === false) {
                const medioP = new MedioPagos();
                medioP.monto = 0;
            }

            var restante = 0;
            var cambio = 0;

            this.esAbono = !buscaMedioPago.esAbono;

            // SI EL MONTO RECIBIDO ES MENOR DE 0, SE REALIZA UNA SUMA DE TODOS LOS MONTOS EN EL GRID
            if (buscaMedioPago.monto < 0) {
                this.totalMedio = 0;
                for (var i = 0; i < this.childMedioPagos.MedioPagosTable.length; i++) {
                    this.totalMedio = this.totalMedio + this.childMedioPagos.MedioPagosTable[i].monto;
                }
                // SI EL MONTO RECIBIDO ES IGUAL A 0, EL TOTAL ES 0
            } else if (buscaMedioPago.monto == 0) {
                this.totalMedio = 0;
            }
            else {
                // SI NINGUNA CONDICION SE CUMPLE ACUMULA LOS MONTOS INGRESADOS
                this.totalMedio = this.totalMedio + buscaMedioPago.monto;
            }
            // MUESTRA EN PANTALLA EL ULTIMO MEDIO DE PAGO INGRESADO
            await this.catalogosForm.patchValue({
                idMedioPago: buscaMedioPago.idMedioPago,
            });

            await this.selectOPtionA();

            if (this.total > this.totalMedio) {
                restante = this.total - this.totalMedio;
            } else if (this.childMedioPagos.esAbono == false) {
                cambio = this.totalMedio - this.total;
            }

            if (buscaMedioPago.monto == 0) {
                this.CajaForm.patchValue({
                    total: 0,
                    restante: 0,
                    cambio: 0,
                    pagado: 0,
                    saldoF: '$0.00',
                    //conRedondeo: true,
                    FechaRecalculo: this.FechaRecalculo,
                });
            } else {
                this.CajaForm.patchValue({
                    restante: restante,
                    cambio: cambio,
                    pagado: this.totalMedio,
                    saldoF: '$0.00',
                    FechaRecalculo: this.FechaRecalculo,
                });
            }

        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            console.log("Paso por childTotal");
        }
    }

    async selectOPtionA() {
        const idMedioPago = this.catalogosForm.controls.idMedioPago.value;
        // console.log('selectOPtionA Medio: ', idMedioPago);
        this.mediopago = this.catMedioPagos.find((x) => x.id === idMedioPago);

    }

    async selectOptionB() {
        //debugger;
        const id = this.catalogosForm.controls.id.value;
        this.usoCFDI = this.catUsoCfdi.find((x) => x.id === id);
    }

    async getAllCatMedioPagos() {
        try {
            const datoRetorno = await this.catMedioPagosService.getAll().toPromise();
            this.catMedioPagos = datoRetorno;
        } catch (e) {
            if (e.response) {
                throw { message: e.response.data };
            } else {
                throw e;
            }
        } finally {
            console.log("Paso por getCatMedioPagos", this.catMedioPagos);
        }
    }

    async getAllCfdiUsos() {
        try {
            const datoRetorno = await this.catCfdiUsosService.getAll().toPromise();
            this.catUsoCfdi = datoRetorno;
        } catch (e) {
            if (e.response) {
                throw { message: e.response.data };
            } else {
                throw e;
            }
        } finally {
            console.log("Paso por getCatUsoCfdi");
        }
    }

    async getAllCfdiUsosByRegimen() {
        try {
            if (this.personaCliente) {
                const datoRetorno = await this.catCfdiUsosService.getByRegimen((this.personaCliente.idRegimenFiscal ? this.personaCliente.idRegimenFiscal : 12)).toPromise();
                if (datoRetorno) {
                    this.catUsoCfdi = null;
                    this.catUsoCfdi = datoRetorno;
                    if(!this.isCFDI){
                        // ASIGNA EL PRIMER CFDI
                        this.usoCFDI = this.catUsoCfdi[0];
                        this.catalogosForm.patchValue({
                            id: this.usoCFDI.id
                        });
                    }
                }
            }
        } catch (e) {
            if (e.response) {
                throw { message: e.response.data };
            } else {
                throw e;
            }
        } finally {
            console.log("Paso por getCatUsoCfdi");
        }
    }

    async buscaSolicitante() {
        try {
            await this.datosFacturacionCaja$.emit();

            const datoRetorno = await this.personaClientesService.getSingleAgua(this._idAgua).toPromise();

            // Carga Datos-FacturaciónCaja Con Persona
            const datosFacturacionCaja = new DatosFacturacionCaja();
            //si tiene datos fiscales
            if (datoRetorno) {

                datosFacturacionCaja.emailSolicitante = datoRetorno.correoElectronico;

                if (datoRetorno.nombre != null) {
                    datosFacturacionCaja.solicitante = datoRetorno.nombre;
                    this.personaCliente.nombre = datoRetorno.nombre;
                    if (datoRetorno.primerApellido != null) {
                        datosFacturacionCaja.solicitante +=
                            " " + datoRetorno.primerApellido;
                        this.personaCliente.primerApellido = datoRetorno.primerApellido;
                    }
                    if (datoRetorno.segundoApellido != null) {
                        datosFacturacionCaja.solicitante +=
                            " " + datoRetorno.segundoApellido;
                        this.personaCliente.segundoApellido = datoRetorno.segundoApellido;
                    }
                } else if (datoRetorno.razonSocial != null) {
                    datosFacturacionCaja.solicitante = datoRetorno.razonSocial;
                    this.personaCliente.razonSocial = datoRetorno.razonSocial;
                }
                if (datoRetorno.rfc != null) {
                    datosFacturacionCaja.rfcSolicitante = datoRetorno.rfc;
                    this.personaCliente.rfc = datoRetorno.rfc;
                } else {
                    datosFacturacionCaja.rfcSolicitante = "XAXX010101000";
                    this.personaCliente.rfc = "XAXX010101000";
                }
                if (datosFacturacionCaja.rfcSolicitante == "XAXX010101000") {
                    this.personaCliente.idRegimenFiscal = 12;
                    datosFacturacionCaja.idRegimenFiscal = 12;
                }
                if (datosFacturacionCaja.rfcSolicitante != "XAXX010101000") {
                    this.personaCliente.idRegimenFiscal = datoRetorno.idRegimenFiscal;
                    datosFacturacionCaja.idRegimenFiscal = datoRetorno.idRegimenFiscal;
                }
                if (datoRetorno.cp != null) {
                    datosFacturacionCaja.cp = datoRetorno.cp;
                    this.personaCliente.cp = datoRetorno.cp;

                }
            }
            else {
                const datoRetorno = await this.personaClientesService.getSingle(1).toPromise();
                this.personaCliente.id = 1;
                if (datoRetorno.nombre != null) {
                    datosFacturacionCaja.solicitante = datoRetorno.nombre;
                    this.personaCliente.nombre = datoRetorno.nombre;
                    if (datoRetorno.primerApellido != null) {
                        datosFacturacionCaja.solicitante +=
                            " " + datoRetorno.primerApellido;
                        this.personaCliente.primerApellido = datoRetorno.primerApellido;
                    }
                    if (datoRetorno.segundoApellido != null) {
                        datosFacturacionCaja.solicitante +=
                            " " + datoRetorno.segundoApellido;
                        this.personaCliente.segundoApellido = datoRetorno.segundoApellido;
                    }
                } else if (datoRetorno.razonSocial != null) {
                    datosFacturacionCaja.solicitante = datoRetorno.razonSocial;
                    this.personaCliente.razonSocial = datoRetorno.razonSocial;
                }
                if (datoRetorno.rfc != null) {
                    datosFacturacionCaja.rfcSolicitante = datoRetorno.rfc;
                    this.personaCliente.rfc = datoRetorno.rfc;
                } else {
                    datosFacturacionCaja.rfcSolicitante = "XAXX010101000";
                    this.personaCliente.rfc = "XAXX010101000";
                }
                if (datosFacturacionCaja.rfcSolicitante == "XAXX010101000") {
                    this.personaCliente.idRegimenFiscal = 12;
                    datosFacturacionCaja.idRegimenFiscal = 12;
                }
                if (datoRetorno.cp != null) {
                    datosFacturacionCaja.cp = datoRetorno.cp;
                    this.personaCliente.cp = datoRetorno.cp;

                }
            }


            await this.datosFacturacionCaja$.emit(datosFacturacionCaja);
            this.datosFacturacion = datosFacturacionCaja;
            //debugger;
            if(datoRetorno?.idUsoCfdi != null){
                this.usoCFDI = null;
                this.usoCFDI = this.catUsoCfdi.find((x) => x.id === datoRetorno.idUsoCfdi);
                this.catalogosForm.patchValue({
                    id: datoRetorno.idUsoCfdi
                });
                this.isCFDI=true;
            }
            else
                await this.getAllCfdiUsosByRegimen();

        } catch (e) {
            if (e.response) {
                throw { message: e.response.data };
            } else {
                throw e;
            }
        } finally {
            console.log("Paso por buscaSolicitante");
        }
    }


    async childPersonaClientes(personaClientes: PersonaClientes) {
        //await this.showDialog1();
        //debugger;

        if (!personaClientes.id) return;

        // Carga Datos-FacturaciónCaja con PersonaClientes
        // console.log("PERSONA CLIENTE", personaClientes);
        let datosFacturacionCajaPC = new DatosFacturacionCaja();

        datosFacturacionCajaPC.emailSolicitante = personaClientes.correoElectronico;
        this.enviaCorreo.correo = personaClientes.correoElectronico;

        if (personaClientes.nombre != null) {
            datosFacturacionCajaPC.solicitante =
                personaClientes.nombre +
                " " +
                personaClientes.primerApellido +
                " " +
                personaClientes.segundoApellido;
        } else {
            datosFacturacionCajaPC.solicitante = personaClientes.razonSocial;
        }
        if (personaClientes.rfc != null || personaClientes.rfc === " ") {
            datosFacturacionCajaPC.rfcSolicitante = personaClientes.rfc;
        } else {
            datosFacturacionCajaPC.rfcSolicitante = "XAXX010101000";
        }

        // console.log("que emite?", datosFacturacionCaja)
        //debugger;
        await this.datosFacturacionCaja$.emit(datosFacturacionCajaPC);
        this.datosFacturacion = datosFacturacionCajaPC;

        //debugger;
        this.personaCliente = personaClientes;
        await this.getAllCfdiUsos();
        
        if(this.personaCliente?.idUsoCfdi != null){

            this.usoCFDI = null;
            this.usoCFDI = this.catUsoCfdi.find((x) => x.id === this.personaCliente.idUsoCfdi);
            this.catalogosForm.patchValue({
                id: this.personaCliente.idUsoCfdi
            });
            this.isCFDI=true;
        }
        else
            await this.getAllCfdiUsosByRegimen();
       

    }

    async limpiaDatosFacturacion() {
        try {
            await this.datosFacturacionCaja$.emit(null);
        } catch (e) {
            if (e.response) {
                throw { message: e.response.data };
            } else {
                throw e;
            }
        }
    }

    async Facturar(idcobro) {
        try {
            this.mensajeForm.patchValue({
                mensaje_: 'Realizando factura, por favor espere...'
            });
            this.showBar();
            this.facturacionData = {
                id: idcobro,
                metodoPago: this.mediopago,
                usoCFDI: this.usoCFDI,
                receptor: this.personaCliente,
            };

            const datoretorno = await this.datosCfdiFacturasService
                .add(this.facturacionData)
                .toPromise();

            if (datoretorno) {
                this.progressBar = false;
                this.respuestaF = datoretorno;

                if (this.respuestaF.estatus != 'OK') {
                    this.mensajeForm.patchValue({
                        mensaje_: this.respuestaF.estatus + '\n \n \n ¿INTENTAR TIMBRAR EL PAGO DE NUEVO?'
                    });
                    this.showErrorTimbre();
                } else {

                    this._id_factura = this.respuestaF.idFactura;
                    this.enviaCorreo.idFactura = this._id_factura;
                    await this.enviarCorreo();

                    await this.imprimeComprobante(
                        this.respuestaF.idFactura,
                        this.respuestaF.tipoRecibo
                    );
                }
            }
        } catch (e) {
            this.progressBar = false;
            this.mensajeForm.patchValue({
                mensaje_: "EXISTE UN ERROR " + '\n \n \n ¿INTENTAR TIMBRAR EL PAGO DE NUEVO?'
            });
            this.showErrorTimbre();
            console.log("Error en Facturar", e);
            // if (e.response) {
            //     throw { message: e.response.data };
            // } else {
            //     throw e;
            // }
        } finally {
            console.log("Paso por Facturar");
        }
    }

    async imprimeComprobante(id_Factura, reporte) {
        try {
            this.auxJasper = new AuxJasper();
            this.auxJasper.JasperReport.tipo = "pdf";

            this.auxJasper.JasperReport.nombreReporte = "001_Factura";

            // console.log("Tipo de Comprobante: ", reporte);
            // -- Parametros --
            const id_factura = new ParametroJasper();
            id_factura.nombre = "_id_factura";
            id_factura.valor = id_Factura + "";
            let reimpresion = new ParametroJasper();
            reimpresion.nombre = 'reimpresion';
            reimpresion.valor = false + "";
            let timbre = new ParametroJasper();
            timbre.nombre = 'timbre';
            const withCopy = new ParametroJasper();
            withCopy.nombre = 'withCopy';
            withCopy.valor = 'wCopy';

            //debugger;
            if (reporte === 1)
                timbre.valor = true + "";
            else
                timbre.valor = false + "";

            await this.auxJasper.ParametroJasper.push(reimpresion);
            await this.auxJasper.ParametroJasper.push(timbre);
            // console.log("Parametro:", id_factura.nombre, "Valor:", id_factura.valor);

            await this.auxJasper.ParametroJasper.push(id_factura);
            await this.auxJasper.ParametroJasper.push(withCopy);

            // console.log("Agui va");
            await this.showDialog();

        } catch (e) {
            if (e.response) {
                throw { message: e.response.data };
            } else {
                throw e;
            }
        } finally {
            console.log("Paso por imprimeComprobante");
        }
    }

    limpiaInput() {
        // console.log('13---------------------------------------');
        // console.log("LIMPIA");
        this.estadoCuentaInformacionInput$.emit(null);
        this.cargosDetallesInput$.emit(null);
    }

    // ====================================================
    // child enviar-correo 
    // ====================================================
    async enviarCorreo() {
        try {
            const datosenviarCorreo = new EnviarCorreo();
            let DatoCorreo = this.childDatosFacturacionCaja.datosFiscalesForm.get('email').value;
            datosenviarCorreo.idFactura = this._id_factura;
            datosenviarCorreo.enviosFactura = true;
            datosenviarCorreo.correo = DatoCorreo == undefined ? "" : DatoCorreo;
            datosenviarCorreo.correocopia = "";

            //validamos si existe un correo enviara la factura
            if (datosenviarCorreo.correo != null && datosenviarCorreo.correo != "" && datosenviarCorreo.correo != undefined) {

                this.mensajeForm.patchValue({
                    mensaje_: 'Eviando factura por correo, por favor espere...'
                });

                this.progressBar = true; 
                const datoretorno = await this.enviarCorreoService.add(datosenviarCorreo).toPromise();
                let respuesta = datoretorno;
                
                if (respuesta.toString() == "OK") { 
                    this.progressBar = false;
                    this.muestraMensaje.notification("Envió de factura por correo exitoso", "top", "center")
                }
                else {
                    this.muestraMensaje.error("No fue posible enviar la factura por correo", "top", "center")
                }
            }
            await this.datosenviarCorreo$.emit(datosenviarCorreo); // ese emite para mostrar el envio de correo de forma manual
        } catch (e) {
            console.log("Error en enviarCorreo", e);
        } finally {
            console.log("Paso por enviarCorreo");
        }
    }

    async confirm() {
        this.errorTimbre = false;
        await this.Facturar(this.idCobro);
    }

    async cancelar() {
        this.errorTimbre = false;
        if (this.respuestaF == null || this.respuestaF == undefined) {
            this.respuestaF = {
                idFactura: this.facturacionData.id,
                tipoRecibo: 2,
                estatus: ""
            };

        }


        await this.imprimeComprobante(
            this.respuestaF.idFactura,
            this.respuestaF.tipoRecibo
        );
    }

    //====================================================================================================================
    //   EFECTUA EL PAGO Y LA FACTURACIÓN (LLAMA AL API)
    //====================================================================================================================
    async RealizaPago() {
        try {
            const datoRetorno = await this.registraPagosService
                .getBusquedas(this.json_in)
                .toPromise();
            // console.log("RESULTADO", datoRetorno);

            if (datoRetorno)
                this.progressBar = false;

            // ===========================================
            //                     FACTURAR
            // ==========================================
            // this.idCobro = datoRetorno[0].idCobro;
            // await this.Facturar(this.idCobro);
            if (datoRetorno[0].idCobro) {
                this.progressBar = false;
                this.idCobro = datoRetorno[0].idCobro;
                // await this.imprimeComprobante(this.idCobro,2);
                if (this.flagFacturacionActiva)
                    await this.Facturar(this.idCobro);
                else
                    this.generateTicket(this.idCobro);
            } else if (!datoRetorno[0].idCobro) {
                let errorP = datoRetorno.toString();
                throw new Error(errorP);
            }

            //=============================================----->>>>>>
            //Refresca datos de pantalla
            //=============================================----->>>>>>

            /*const cargosDetallesInput = new CargosDetallesInput();
            cargosDetallesInput.idAgua = this.aguasProceso.id;
            cargosDetallesInput.idEstatus = 1;
            await this.cargosDetallesInput$.emit(cargosDetallesInput);*/

            await this.childMedioPagos.limpiaGrid();
            let newBusqueda = new Aguas();
            newBusqueda.id = this.idAguasProceso;
            this.childAguaBuscaCuentas(newBusqueda.id);
            //this.personas$ = await this.personasService.getSingle(0);
        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");

        } finally {
            console.log("Paso por getRAguasPersonas");
            this.progressBar = false;
            if (this.noLimpiar) {
                this.childAguaBuscaCuentas(this.aguasInput);
            }
        }

    }
    async generateTicket(idCobro: number) {
        // get coded string 

        const ticketContent = await this.ticketService.getCryptedTicket(idCobro).toPromise();
        // Crear un nuevo Blob con el contenido del ticket
        const blob = new Blob([ticketContent], { type: 'text/plain;charset=utf-8' });

        // Guardar el archivo en una carpeta específica con el nombre "ticket.txt"
        saveAs(blob, '6e8788b6-d7cb-4961-adc0-0c3fa525924b.dat');
    }

    async confirmaPago() {
        //=================================================================================
        // Ventana de confirmación Pago
        //=================================================================================
        var metodosPagos = "";
        var metodoItem = new CatMedioPagos();
        var monto = 0;

        this.json_in.MedioPagos_in.forEach(element => {
            metodoItem = this.catMedioPagos.find((x) => x.id === element.idMedioPago);
            monto = monto + element.monto;
            metodosPagos = metodosPagos + metodoItem.descripcion + ", "
        });

        if (metodosPagos.length > 0) metodosPagos = metodosPagos.substring(0, metodosPagos.length - 2);

        if(this.conRedondeo){
            monto = Math.ceil(monto);
        }else{
            monto = monto;
        }
        await this.confirmationService1.confirm({
            message: '<b>Solicitante  :</b> ' + (this.personaCliente.nombre == null || this.personaCliente.nombre == '' ? this.personaCliente.razonSocial : this.personaCliente.nombre) + "<br>"
                /* + '<b>RFC: </b>    ' + this.personaCliente.rfc + "<br>"*/
                + '<b>Medio de Pago: </b>' + metodosPagos + "<br>"
                + '<b>Total:</b>' + new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(monto),
            accept: () => {
                this.mensajeForm.patchValue({mensaje_: 'Realizando pago, por favor espere...'});
                this.showBar();
                this.RealizaPago();
            },
            reject: () => {return;}
            , acceptLabel: "Si"
        });
    }

    async totalAdeudoOutput(totalAdeudo: number) {
        try {
            //this.childEstadoCuentaInformacion.estadoCuentaTable[0].total = totalAdeudo;

            // Carga datos del estado de cuanta
            let estadoCuentaInformacionInput = new EstadoCuentaInformacionInput();
            estadoCuentaInformacionInput.idAgua = this._idAgua;
            await this.estadoCuentaInformacionInput$.emit(estadoCuentaInformacionInput);

        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
            console.log(this.muestraMensaje.error);
        } finally {
            console.log("Paso por totalAdeudoOutput");
        }
    }

    // COMENTADA PARA EVITAR LA VALIDACION DE ANOMALIAS

    // totalAnomaliasOutput(totalAnomalias: number) {

    //     if (totalAnomalias > 0) {
    //         this.muestraMensaje.error('No se puede pagar por qué tiene anomalías en consumos.', "top", "center");
    //         this.flag = true;
    //     }
    // }

    async buscaConvenio(idAgua: number) {

        let buscaConveniosInput = new BuscaConveniosInput;
        buscaConveniosInput.idAgua = idAgua;

        const datoRetorno = await this.conveniosChildService.getConvenioMigrado(buscaConveniosInput).toPromise();

        datoRetorno.forEach(element => {
            if (element.idEstatus == 6) {
                if (this.convenioActivo != true) {
                    this.muestraMensaje.error('La cuenta tiene un convenio anterior, favor de pasar a liquidación.', "top", "center");
                }
                this.flag = true;
                this.convenioActivo = true;
            }
        });
    }


    async estadoCuentaInformacion(estado) {
        try {
            this.CajaForm.patchValue({ saldoF: (estado[0]?.abono).toString(), });

            if (this.childEstadoCuentaInformacion.estadoCuentaTable[0].estatus == "CANCELADO") {
                this.flag = true;
                throw new Error('No se puede realizar pagos para una cuenta cancelada.');
            }

            if (this.childEstadoCuentaInformacion.estadoCuentaTable[0].bloqueoVigente != null) {
                const inputJson = { "id_operacion": 1, "id_agua": this._idAgua };
                const datoRetorno = await this.execDbService.processJsonData(inputJson).toPromise();

                if (!datoRetorno.data[0].cobra) {
                    this.flag = true;
                    throw new Error('No se puede realizar pagos para una cuenta bloqueada.');
                }
            }
        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
        }
    }

    async Recalcular() {
        try {
            //validaciones
            const caja = this.CajaForm.value;

            if (this._idAgua == undefined) throw new Error("Búsque primeramente una cuenta.");
            if (caja.FechaRecalculo == null) throw new Error("Seleccione una fecha de recalculo.");


            // Carga detalle adeudos
            const cargosDetallesInput = new CargosDetallesInput();
            cargosDetallesInput.idAgua = this._idAgua;
            cargosDetallesInput.idEstatus = 1;
            cargosDetallesInput.fechaCalculos = caja.FechaRecalculo;
            await this.cargosDetallesInput$.emit(cargosDetallesInput);

            this.FechaRecalculo = caja.FechaRecalculo;

        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
            console.log(this.muestraMensaje.error);
        } finally {
            console.log("Paso por Recalcular");
        }
    }
    onCheckboxChange(event: any) {
        this.conRedondeo =event.checked;
        this.childtotal(null);
      }

}


